import moment from 'moment'

export function DateFormatFilter() {
  return (input: string, action: string) => {
    input = input || ''
    try {
      return moment(input).calendar(null, {
        sameDay: '[Today at] HH:mm',
        lastDay: '[Yesterday at] HH:mm',
        nextDay: 'YYYY-MM-DD [at] HH:mm',
        nextWeek: 'YYYY-MM-DD [at] HH:mm',
        lastWeek: 'YYYY-MM-DD [at] HH:mm',
        sameElse: 'YYYY-MM-DD [at] HH:mm',
      })
    } catch (e) {
      return ''
    }
  }
}
